import axios from "axios";

export const uploadReplenishmentStockUpdate = (file) => {
    const path = __API__ + '/api/sap/module/replenishmentstock';

    const config = {
        validateStatus: (status) => status === 200,
    };

    let formData = new FormData();
    formData.append('file', file);

    return axios.put(path, formData, config);
};


// WEBPACK FOOTER //
// ./src/admin/services/ModulesModule.js